// @flow

import * as React from 'react';
import { bindActionCreators } from 'redux';
import connect from '@active/awe-ui-core/lib/hoc/connect';
import PageBody from 'components/PageBody/PageBody';
import L10nMessage from 'react-aaui/lib/shared/L10nMessage';
import RoleFilter from 'components/RoleFilter/RoleFilter';
import { UserRole } from 'modules/user/enum';

import Header from './Header/Header';
import RecentEvents from './RecentEvents/RecentEvents';
import SpecialRoleSignUp from './SpecialRoleSignUp/SpecialRoleSignUp';
import { onMount } from './duck/duck';
import './Home.scss';
import './duck/epics';

class Home extends React.Component<*, *> {
  componentDidMount() {
    this.props.onMount();
  }

  render() {
    const { history } = this.props;
    return (
      <div className="page">
        <Header history={history} />
        <PageBody>
          <h1 className="home-content__recent-event"><L10nMessage id="page.home.content.recentEvents" /></h1>
          <RecentEvents />
        </PageBody>
        <RoleFilter blockedRoles={[ UserRole.TIMER ]}>
          <SpecialRoleSignUp />
        </RoleFilter>
      </div>
    );
  }
}

const mapDispatch = dispatch => bindActionCreators({ onMount }, dispatch);

export default connect(null, mapDispatch)(Home);
